(function () {
  /* 特別価格キャンペーン（2026-11開始）。期限は「今月末」を自動表示（終了の指示があるまで毎月延長） */
  var JN = new Date(Date.now() + 9 * 3600000);
  var DL = (JN.getUTCMonth() + 1) + '月' + new Date(Date.UTC(JN.getUTCFullYear(), JN.getUTCMonth() + 1, 0)).getUTCDate() + '日';
  var T = {
    glass_normal: ['20|20|20', '30|18|24', '36|22|26', '45|27|20', '60|30|25', '60|45|36', '30|30|30', '45|27|30', '45|30|30', '45|45|45', '60|30|36', '60|30|45', '60|45|45', '60|60|60', '90|45|45', '120|45|45'],
    acrylic_normal: ['60|30|36', '60|30|45', '60|45|45', '60|60|60', '90|45|45', '120|45|45']
  };
  /* 通常価格（この金額の表示にだけ帯を付ける。OF水槽などの同サイズには付けない） */
  var P = {
    '20|20|20': [6130], '30|18|24': [6130], '36|22|26': [7800], '45|27|20': [7800], '60|30|25': [8320], '60|45|36': [15800],
    '30|30|30': [7550], '45|27|30': [7800], '45|30|30': [8020], '45|45|45': [18860],
    '60|30|36': [9460, 41390, 45690], '60|30|45': [18920, 41390, 45690], '60|45|45': [22660, 51840, 56140],
    '60|60|60': [75460, 91160, 95460], '90|45|45': [39600, 67240, 71540], '120|45|45': [84920, 80710, 85010]
  };
  var BADGE = DL + 'まで特別価格あり｜詳しくはお問い合わせ';
  var BADGE_S = (JN.getUTCMonth() + 1) + '/' + new Date(Date.UTC(JN.getUTCFullYear(), JN.getUTCMonth() + 1, 0)).getUTCDate() + 'まで特別価格';
  var css = '.spc-b{display:inline-block;box-sizing:border-box;max-width:100%;margin:4px 0 0;padding:2px 8px;border-radius:4px;background:#d61f1f;color:#fff!important;font-size:11px;font-weight:800;line-height:1.45;white-space:normal;word-break:normal;overflow-wrap:anywhere;letter-spacing:0;text-align:left}' +
    '.spc-b.is-s{display:block;width:fit-content;padding:1px 6px;font-size:10px;white-space:normal}' +
    '@media (max-width:749px){.spc-b{font-size:10.5px;padding:2px 6px}.spc-b.is-s{font-size:9.5px;padding:1px 5px}}' +
    '.spc-box{margin:12px 0;padding:14px 16px;border:2px solid #d61f1f;border-radius:10px;background:#fff5f5;color:#222;font-size:14px;line-height:1.7}' +
    '.spc-strike,.spc-strike *{text-decoration:line-through!important;text-decoration-color:#d61f1f!important;text-decoration-thickness:2px!important}.spc-strike .spc-b{text-decoration:none!important}' +
    '.spc-box b{display:block;color:#d61f1f;font-size:16px;margin-bottom:2px}' +
    '.spc-box a{display:inline-block;margin-top:8px;padding:10px 18px;border-radius:999px;background:#d61f1f;color:#fff!important;font-weight:800;text-decoration:none!important}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function badge() { var s = document.createElement('span'); s.className = 'spc-b'; s.textContent = BADGE; return s; }
  function badgeS() { var s = document.createElement('span'); s.className = 'spc-b is-s'; s.textContent = BADGE_S; return s; }
  function num(t) { var m = String(t).replace(/,/g, '').match(/(\d{4,7})\s*円|¥\s*(\d{4,7})/); if (!m) return 0; return parseInt(m[1] || m[2], 10); }
  /* セルやボタン内の金額の文字だけに赤い取り消し線 */
  function strikeText(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), list = [], nd;
    while ((nd = w.nextNode())) { if (/[¥￥]?\s*\d{1,3}(,\d{3})+\s*円?|¥\s*\d{4,7}|\d{4,7}\s*円/.test(nd.nodeValue)) list.push(nd); }
    list.forEach(function (t) {
      var m = t.nodeValue.match(/[¥￥]?\s*\d{1,3}(,\d{3})+\s*円?|¥\s*\d{4,7}|\d{4,7}\s*円/);
      if (!m) return;
      var i = m.index, sp = document.createElement('span'); sp.className = 'spc-strike'; sp.textContent = m[0];
      var after = t.splitText(i); after.nodeValue = after.nodeValue.slice(m[0].length);
      t.parentNode.insertBefore(sp, after);
    });
  }
  function sizeKey(t) {
    var m = String(t).match(/W?\s*(\d{2,4})\s*[×xX]\s*D?\s*(\d{2,4})\s*[×xX]\s*H?\s*(\d{2,4})/);
    if (!m) return '';
    var a = [m[1], m[2], m[3]].map(function (x) { var n = parseInt(x, 10); if (n >= 250) n = n / 10; return n; });
    return a.join('|');
  }

  /* 価格表：対象サイズの通常価格のセルに帯を付ける */
  function tables() {
    var rows = document.querySelectorAll('tr, .ca2-prow');
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (r.getAttribute('data-spc')) continue;
      r.setAttribute('data-spc', '1');
      var k = '', cs = r.querySelectorAll('td, th, .ca2-size small');
      for (var q = 0; q < cs.length; q++) { k = sizeKey(cs[q].textContent); if (k) break; }
      if (!k) continue;
      var ok = P[k];
      if (!ok) continue;
      var cells = r.querySelectorAll('td, .ca2-pc');
      for (var j = 0; j < cells.length; j++) {
        var c = cells[j];
        if (c.textContent.indexOf('〜') > -1) continue;
        var n = num(c.textContent);
        if (n) { if (ok.indexOf(n) > -1) { strikeText(c); c.appendChild(badgeS()); } }
      }
    }
  }

  /* シミュレーター */
  function v(id) { var e = document.getElementById(id); return e ? e.value : ''; }
  function hit() {
    if (!document.getElementById('aqr6_s_type')) return false;
    if (v('aqr6_s_mode') === 'stand_only') return false;
    var l = T[v('aqr6_s_type')];
    if (!l) return false;
    return l.indexOf(v('aqr6_s_w') + '|' + v('aqr6_s_d') + '|' + v('aqr6_s_h')) > -1;
  }
  var isShop = location.hostname.indexOf('suiso-sozai') > -1;
  function sim() {
    var total = document.getElementById('aqr6-r_total');
    if (!total) return;
    var on = hit();
    var b = document.getElementById('spc-sim-b');
    if (on) {
      if (!b) { b = badge(); b.id = 'spc-sim-b'; b.style.display = 'block'; total.parentNode.insertBefore(b, total.nextSibling); }
      b.style.display = 'block';
      total.classList.add('spc-strike');
    } else { if (b) b.style.display = 'none'; total.classList.remove('spc-strike'); }
    var mp = document.querySelector('.aqrm-price'); if (mp) mp.classList.toggle('spc-strike', on);
    if (!isShop) return;
    var cart = document.getElementById('aqr8-cart');
    var box = document.getElementById('spc-sim-box');
    if (on) {
      if (cart) cart.style.display = 'none'; var sg = document.getElementById('aqr8-suggest'); if (sg) { sg.style.display = 'none'; sg.setAttribute('data-spc-hid', '1'); }
      var spec = '【特別価格のお問い合わせ】' + (v('aqr6_s_type') === 'acrylic_normal' ? 'アクリル水槽' : 'ガラス水槽') + ' W' + v('aqr6_s_w') + '×D' + v('aqr6_s_d') + '×H' + v('aqr6_s_h') + 'cm';
      if (!box) {
        box = document.createElement('div'); box.id = 'spc-sim-box'; box.className = 'spc-box';
        var anchor = cart || total.parentNode;
        anchor.parentNode.insertBefore(box, anchor);
      }
      box.innerHTML = '<b>' + BADGE + '</b>このサイズは' + DL + 'まで特別価格でご案内しています。カートではなく、お問い合わせからご注文ください。<br><a href="/pages/contact?sim_data=' + encodeURIComponent(spec) + '#form">特別価格を問い合わせる</a>';
      box.style.display = '';
    } else {
      if (cart) cart.style.display = ''; var sg2 = document.getElementById('aqr8-suggest'); if (sg2) { if (sg2.getAttribute('data-spc-hid')) { sg2.style.display = ''; sg2.removeAttribute('data-spc-hid'); } }
      if (box) box.style.display = 'none';
    }
  }

  /* アクアレンタリウム：見積り送信後の「今すぐ注文する」を止める */
  function cfgHit(cfg) {
    if (!cfg) return false;
    if (cfg.mode === 'stand_only') return false;
    var l = T[cfg.type];
    if (!l) return false;
    return l.indexOf(cfg.W + '|' + cfg.D + '|' + cfg.H) > -1;
  }
  function thanks() {
    var btn = document.getElementById('aqt-order-btn');
    if (!btn) return;
    var cfg = null;
    try { cfg = JSON.parse(sessionStorage.getItem('aqrSimCfg') || 'null'); } catch (e) { cfg = null; }
    if (!cfgHit(cfg)) return;
    if (btn.getAttribute('data-spc')) return;
    btn.setAttribute('data-spc', '1');
    var box = document.createElement('div'); box.className = 'spc-box';
    box.innerHTML = '<b>' + BADGE + '</b>お選びのサイズは' + DL + 'まで特別価格でご案内しています。担当者から特別価格のお見積りをお送りしますので、このままお待ちください。';
    btn.parentNode.insertBefore(box, btn);
    btn.style.display = 'none';
  }
  function confirmGuard() {
    if (location.pathname.indexOf('/order-confirm') !== 0) return;
    var m = location.hash.match(/cfg=([^#]+)/);
    var cfg = null;
    if (m) { try { cfg = JSON.parse(decodeURIComponent(m[1])); } catch (e) { cfg = null; } }
    if (!cfg) { try { cfg = JSON.parse(sessionStorage.getItem('aqrSimCfg') || 'null'); } catch (e) { cfg = null; } }
    if (!cfgHit(cfg)) return;
    var main = document.querySelector('.l-mainContent') || document.body;
    main.innerHTML = '<div class="spc-box" style="max-width:640px;margin:40px auto"><b>' + BADGE + '</b>お選びのサイズは' + DL + 'まで特別価格でご案内しています。オンラインでのご注文はできませんので、担当者からのお見積りをお待ちいただくか、お問い合わせください。</div>';
  }

  /* 水槽素材の商品ページ：カートの代わりに問い合わせボタン（対象商品は snippets/spc-campaign.liquid で window.spcProduct を出力） */
  function product() {
    var sp = window.spcProduct;
    if (!sp) return;
    if (document.getElementById('spc-prod-box')) return;
    var pf = document.querySelector('product-form');
    if (!pf) return;
    var box = document.createElement('div'); box.id = 'spc-prod-box'; box.className = 'spc-box';
    var href = '/pages/contact?consult=1' + String.fromCharCode(38) + 'item=' + encodeURIComponent('【特別価格】' + sp.title) + String.fromCharCode(38) + 'url=' + encodeURIComponent(sp.url);
    box.innerHTML = '<b>' + BADGE + '</b>この商品は期間限定の特別価格でご案内しています。カートではなく、お問い合わせからご注文ください。担当者から特別価格のお見積りをお送りします。<br><a href="' + href + '">特別価格を問い合わせる</a>';
    var host = pf.parentNode;
    host.parentNode.insertBefore(box, host);
  }

  /* ガラス・アクリルの価格一覧ページのシミュレーター（サイズボタン＋本体価格 #aqa-price） */
  function chips() {
    var bs = document.querySelectorAll('button');
    for (var i = 0; i < bs.length; i++) {
      var b = bs[i];
      if (b.getAttribute('data-spc')) continue;
      var nb = b.querySelector('b'), sm = b.querySelector('small');
      if (!nb) continue;
      if (!sm) continue;
      var mw = nb.textContent.match(/(\d+)cm/);
      var m2 = sm.textContent.replace(/,/g, '').match(/D(\d+)\s*×\s*H(\d+)\s*¥(\d+)/);
      if (!mw) continue;
      if (!m2) continue;
      b.setAttribute('data-spc', '1');
      var k = mw[1] + '|' + (m2[1] / 10) + '|' + (m2[2] / 10);
      var ok = P[k];
      if (!ok) continue;
      if (ok.indexOf(parseInt(m2[3], 10)) < 0) continue;
      b.setAttribute('data-spc-hit', m2[3]);
      strikeText(sm);
      b.appendChild(badgeS());
    }
    var pe = document.getElementById('aqa-price');
    if (!pe) return;
    var on = document.querySelector('button.is-on[data-spc-hit]');
    var hitOn = false;
    if (on) hitOn = num(pe.textContent) === parseInt(on.getAttribute('data-spc-hit'), 10);
    var bb = document.getElementById('spc-aqa-b');
    if (hitOn) {
      if (!bb) { bb = badge(); bb.id = 'spc-aqa-b'; bb.style.display = 'block'; pe.parentNode.insertBefore(bb, pe.nextSibling); }
      bb.style.display = 'block';
      pe.classList.add('spc-strike');
    } else { if (bb) bb.style.display = 'none'; pe.classList.remove('spc-strike'); }
  }

  function run() { tables(); sim(); thanks(); product(); chips(); }
  function init() {
    confirmGuard();
    run();
    document.addEventListener('change', function (e) { if (e.target) { if (String(e.target.id).indexOf('aqr6_') === 0) setTimeout(sim, 50); } }, true);
    document.addEventListener('click', function () { setTimeout(sim, 80); setTimeout(chips, 120); }, true);
    var n = 0, t = setInterval(function () { run(); n++; if (n > 20) clearInterval(t); }, 500);
    var cart = document.getElementById('aqr8-cart');
    if (cart) { if (window.MutationObserver) new MutationObserver(function () { sim(); }).observe(cart, { childList: true, subtree: true }); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
